import { Outlet, Route, Routes } from 'react-router-dom'
import { PageTitle } from '../../../../_metronic/layout/core'
import { useT } from '_metronic/i18n/Metronici18n'
import { PegaPlantaoListWrapper } from './pega-plantao-list/PegaPlantaoList'

export const PegaPlantaoPage = () => {
  const { t } = useT()

  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path=''
          element={
            <>
              <PageTitle description={t('pagina.agenda.descricao')}>Agenda</PageTitle>
              <PegaPlantaoListWrapper />
            </>
          }
        />
      </Route>
    </Routes>
  )
}
